import { isHeycarBOP, OriginSystem } from '../../common/JourneyType';
import { Analytics } from "../../services/analytics";
import { setActualPage } from '../page.utils';

const pageName = "Signature success";
const defaultTrackingData = {
  [Analytics.keys.pageName()]: pageName,
  [Analytics.keys.viewChange()]: pageName,
};

export const trackPage = () => {
    setTimeout(() => {
      setActualPage(pageName);
      const pageData = {
        [Analytics.keys.eventType(0)]: "Legitimation",
        [Analytics.keys.eventAction(0)]: "Success",
        [Analytics.keys.eventType(1)]: "e-signature",
        [Analytics.keys.eventAction(1)]: "Success",
        [Analytics.keys.eventType(2)]: "Sale",
        [Analytics.keys.eventAction(2)]: "Success",
        [Analytics.keys.eventType(3)]: "Product journey",
        [Analytics.keys.eventAction(3)]: "End",
      };
      Analytics.setTrackingData({ ...defaultTrackingData, ...pageData });
      Analytics.trackPage();
    }, 1000);
    setActualPage(pageName);
  };
export const trackButton = (originSystem: OriginSystem) => {
    const specificData = {
      [Analytics.keys.eventType(0)]: "interAction",
      [Analytics.keys.eventAction(0)]: "Success",
      [Analytics.keys.linkInformation(0)]: isHeycarBOP(originSystem)
        ? "Next steps"
        : "Conclude purchase agreement",
    };
    Analytics.setTrackingData({ ...defaultTrackingData, ...specificData });
    Analytics.trackInteraction();
  };